'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fr = require('./fr');

Object.defineProperty(exports, 'fr', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fr).default;
  }
});

var _en = require('./en');

Object.defineProperty(exports, 'en', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_en).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/locales/index.js
// module id = 705
// module chunks = 0